"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _discoverMitsubishi = _interopRequireDefault(require("./discover-mitsubishi.props/discover-mitsubishi.defaultProps"));
var _discoverMitsubishi2 = _interopRequireDefault(require("./discover-mitsubishi.props/discover-mitsubishi.propTypes"));
var _videoBackgroundButton = _interopRequireDefault(require("./video-background-button"));
var _backgroundImage = _interopRequireDefault(require("./background-image"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var VideoBackground = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(VideoBackground, _React$Component);
  function VideoBackground(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var breakpointWidth = 768;
    _this.heroVideo = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      videoIsPlaying: false,
      readyState: 0,
      isDesktop: typeof window !== 'undefined' && window.innerWidth > breakpointWidth
    };
    _this.toggleVideoPlay = _this.toggleVideoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPlay = _this.videoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPause = _this.videoPause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVideoReady = _this.handleVideoReady.bind((0, _assertThisInitialized2["default"])(_this));
    _this.shouldPreload = _this.shouldPreload.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = VideoBackground.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.heroVideo.current !== null && this.state.readyState === 0) {
      this.heroVideo.current.addEventListener('pause', this.videoPause);
      if (this.state.isDesktop) this.handleVideoReady();
      if (typeof window !== 'undefined' && this.state.isDesktop) {
        this.heroVideo.current.addEventListener('canplay', this.videoPlay);
      }
      this.setState(function (prevState) {
        // eslint-disable-line
        return {
          readyState: prevState.readyState
        };
      });
    }
  };
  _proto.handleVideoReady = function handleVideoReady() {
    this.videoPlay();
  };
  _proto.videoPause = function videoPause() {
    this.heroVideo.current.pause();
    this.setState({
      videoIsPlaying: false
    });
  };
  _proto.videoPlay = function videoPlay() {
    this.heroVideo.current.play();
    this.setState({
      videoIsPlaying: true
    });
  };
  _proto.toggleVideoPlay = function toggleVideoPlay(videoIsPlaying) {
    if (videoIsPlaying) {
      this.videoPause();
    } else {
      this.videoPlay();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.heroVideo.current !== null) {
      this.heroVideo.current.removeEventListener('canplay', this.videoPlay);
      this.heroVideo.current.removeEventListener('pause', this.videoPause);
    }
  };
  _proto.shouldPreload = function shouldPreload(isDesktop) {
    if (typeof window !== 'undefined' && isDesktop) {
      return 'auto';
    }
    return 'none';
  };
  _proto.renderVideo = function renderVideo(data, theme) {
    var loopLocal = handleNestedProp(data, 'data.video.loop');
    var _this$state = this.state,
      videoIsPlaying = _this$state.videoIsPlaying,
      isDesktop = _this$state.isDesktop;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("video", {
      ref: this.heroVideo,
      loop: loopLocal || 'true',
      muted: true,
      preload: this.shouldPreload(isDesktop),
      playsInline: true,
      poster: handleNestedProp(data, 'data.image.image')
    }, /*#__PURE__*/_react["default"].createElement("source", {
      src: handleNestedProp(data, 'data.video.source'),
      type: "video/mp4"
    })), /*#__PURE__*/_react["default"].createElement(_videoBackgroundButton["default"], {
      data: data,
      videoIsPlaying: videoIsPlaying,
      theme: theme,
      toggleVideoPlay: this.toggleVideoPlay
    }));
  };
  _proto.renderBackground = function renderBackground(data) {
    return /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
      imgSource: handleNestedProp(data, 'data.image.image'),
      imgAltText: handleNestedProp(data, 'data.image.altText')
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, this.renderVideo(data, theme));
  };
  return VideoBackground;
}(_react["default"].Component);
VideoBackground.defaultProps = {
  data: _discoverMitsubishi["default"],
  theme: {}
};
var _default = VideoBackground;
exports["default"] = _default;